import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';

export default function getPicEqrDocumentsCountForExecutiveReview(state = initialstate.auditphaseMilestoneDetailsForExecutiveReview, action) {
	switch (action.type) {
		case types.GET_AUDITPHASE_MILESTONE_DETAILS_EXECUTIVEREVIEW: {
			if (action.response && action.response.items && action.response.items.length > 0) {
				let newState = _.cloneDeep(action.response);
				if (action.filterAuditPhaseMilestone) {
					newState['items'] = _.filter(newState.items, (item) => {
						return item.taskOpenCount + item.taskInProgressCount + item.taskInReviewCount + item.taskCompleteCount > 0;
					});
				}
				newState['auditPhaseId'] = action.response && action.response.defaultTab;
				return newState;
			}
			return state;
		}

		default:
			return state;
	}
}